export const MAX_FILE_BYTES = 10 * 1024 * 1024;
export const LARGE_FILE_BYTES = 2 * 1024 * 1024;

export function decodeUtf8File(bytes: Uint8Array): { text: string; hadBom: boolean; lineEnding: "LF" | "CRLF" } {
  const hadBom = bytes.length >= 3 && bytes[0] === 0xef && bytes[1] === 0xbb && bytes[2] === 0xbf;
  const text = new TextDecoder("utf-8", { fatal: true }).decode(hadBom ? bytes.subarray(3) : bytes);
  return { text, hadBom, lineEnding: /\r\n/.test(text) ? "CRLF" : "LF" };
}

export function encodeUtf8File(text: string, lineEnding: "LF" | "CRLF", hadBom: boolean): Uint8Array {
  const normalized = text.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
  const body = new TextEncoder().encode(lineEnding === "CRLF" ? normalized.replace(/\n/g, "\r\n") : normalized);
  if (!hadBom) return body;
  const result = new Uint8Array(body.length + 3); result.set([0xef, 0xbb, 0xbf]); result.set(body, 3); return result;
}
